<!-- Component global d'affiche des infos d'un écran
 avec ses campagnes et ses diffusions
  -->

<div class="screenContainer">
    <div class="screenInfos" id="screenInfo">
        <div id="screenHeader">
            <mat-icon class="tagListBtn" [matMenuTriggerFor]="menu">list</mat-icon>
            <!-- MARK: Image de l'écran -->
            @if (face?.thumbnailStorageId) {
                <img
                    class="screenImgContainer"
                    alt="Miniature de l'écran"
                    (click)="playScreenFile(face.storageId)"
                    src="{{ baseUrl }}/file/getFile/{{ face.thumbnailStorageId }}/{{ face.thumbnailStorageId }}"
                />
            } @else if (userAuth$.hasRight('CanEditScreenPicture') && screenType === 'Client') {
                <div class="screenImgContainer noPhotoContainer" (click)="openScreenUploader()">
                    <span>Dispositif sans photo</span>
                    <span>Ajoutez votre photo ici</span>
                </div>
            } @else {
                <div class="screenImgContainer noPhotoContainer">
                    <span>Dispositif sans photo</span>
                </div>
            }

            <!-- MARK: Infos de l'écran -->
            <div class="screenInfoContainer">
                @if (screenType === 'Wancom') {
                    <p class="screenName" matTooltip="{{ face.screenCode }}">
                        {{ face.screenCode }}
                    </p>
                }
                @if (screenType === 'Client') {
                    <!-- Pastille d'état du device -->
                    <div class="title">
                        @if (poweredFaceIds && face.isMagicInfo) {
                            @if (face.powerStatus_MagicInfo == 4) {
                                <mat-spinner
                                    matTooltip="Chargement du statut de l'écran ..."
                                    [diameter]="15"
                                    style="margin-right: 5px"
                                ></mat-spinner>
                            } @else if (face.powerStatus_MagicInfo < 4 && face.powerStatus_MagicInfo >= 1) {
                                <div
                                    class="powerBadge"
                                    [ngClass]="[
                                        face.powerStatus_MagicInfo == 1 ? 'On' : '',
                                        face.powerStatus_MagicInfo == 2 ? 'Off' : '',
                                        face.powerStatus_MagicInfo == 3 ? 'HalfOn' : '',
                                    ]"
                                    matTooltip="{{
                                        face.powerStatus_MagicInfo == 3
                                            ? 'Tous les écrans de la face ne sont pas allumés'
                                            : ''
                                    }}"
                                ></div>
                            }
                        }
                        @if (!poweredFaceIds && face.isMagicInfo && userAuth$.hasRight('CanSeeMonitoring')) {
                            <mat-spinner [diameter]="15" style="margin-right: 5px"></mat-spinner>
                        }
                        <p class="screenName" matTooltip="{{ face.screenCode }}">
                            {{ face.screenCode }}
                        </p>
                    </div>
                }
                <!-- Adresse -->
                <p class="screenAdress">
                    {{ face.address }}
                    @if (face.address != null && face.address != '') {
                        <br />
                    }
                    {{ face.zipCode }} {{ face.name }}
                </p>
                <!-- Ratio de l'écran -->
                <p
                    class="sizeInfo"
                    matTooltip="Résolution de l'écran:  {{ face.pixelWidth }}px * {{ face.pixelHeight }}px"
                >
                    <span class="material-icons"> aspect_ratio </span>
                    {{ face.pixelWidth }}*{{ face.pixelHeight }} px -
                    {{ screen$.getAspectRatio(face.pixelWidth, face.pixelHeight) }}
                </p>
                <!-- Horaires -->
                @if (screenType === 'Wancom') {
                    @for (timeWork of face.timeWorks; track $index) {
                        <div class="screenTimeWork">
                            <div class="screenName" style="width: 30%">{{ getDayofWeeks(timeWork.dayOfWeek) }}:</div>
                            <div>
                                <span>{{ timeWork.startPlayer }} - {{ timeWork.endPlayer }}</span>
                            </div>
                        </div>
                    }
                }
                <!-- MARK: Tags -->
                @if (face.tags) {
                    <span class="tagList">
                        @for (tag of face.tags; track $index) {
                            <span
                                class="tag"
                                [ngClass]="{
                                    selected: filterParams.tags.includes(tag.tagId),
                                }"
                            >
                                <mat-icon class="chipCatIcon">{{ getTagIcon(tag.tagId) }}</mat-icon>
                                {{ tag.name }}
                            </span>
                        }
                    </span>
                }
            </div>
        </div>
        <!-- MARK: Menu -->
        <mat-menu #menu="matMenu" class="screenMenu">
            <span class="faceId">ID : {{ face.faceId }}</span>
            @if (face.lat != null && face.lon != null) {
                <button mat-menu-item (click)="seeScreenMap(face.lat, face.lon)">
                    <mat-icon>map</mat-icon>
                    <span>Localiser l'écran</span>
                </button>
            }
            <!-- Redirect to TimeLine -->
            <button mat-menu-item (click)="redirectToTimeline(face)">
                <mat-icon>view_timeline</mat-icon>
                <span>Voir dans la Timeline</span>
            </button>

            @if (screenType === 'Client') {
                @if (userAuth$.hasRight('CanCreateTicketOnScreen')) {
                    <button mat-menu-item (click)="createTicket(face)">
                        <mat-icon>build</mat-icon>
                        <span>Créer un ticket</span>
                    </button>
                }

                @if (userAuth$.hasRight('CanEditTimeScreen') && face.isMagicInfo && face.powerStatus_MagicInfo === 1) {
                    <button mat-menu-item (click)="openScreenParameters(face)">
                        <mat-icon>edit</mat-icon>
                        <span>Modifier les horaires</span>
                    </button>
                }

                @if (face.powerStatus_MagicInfo !== 1 || (face.powerStatus_MagicInfo === 1 && !face.isMagicInfo)) {
                    <button mat-menu-item (click)="openScreenParameters(face)">
                        <mat-icon>visibility</mat-icon>
                        <span>Voir les horaires de l'écran</span>
                    </button>
                }

                @if (
                    face.timeWorks.length == 0 &&
                    userAuth$.hasRight('CanEditTimeScreen') &&
                    face.isMagicInfo &&
                    face?.powerStatus_MagicInfo === 1
                ) {
                    <button (click)="openScreenParameters(face)" mat-menu-item>
                        <mat-icon>more_time</mat-icon>
                        <span>Ajouter les horaires de l'écran</span>
                    </button>
                }

                @if (userAuth$.hasRight('CanEditScreenPicture')){
                    <button (click)="deletePic(face)" mat-menu-item>
                        <mat-icon>hide_image</mat-icon>
                        <span>Supprimer l'image de l'écan</span>
                    </button>
                }

                @if (userAuth$.hasRight('CanTurnOnOffScreen')) {
                    <div mat-menu-item>
                        <button
                            mat-button
                            class="poweredButton"
                            style="margin-right: 5px"
                            (click)="setPowerDevice(face, true)"
                        >
                            <mat-icon>power_settings_new</mat-icon>
                            <span>On</span>
                        </button>
                        <button class="poweredButton" mat-button (click)="setPowerDevice(face, false)">
                            <mat-icon>power_settings_new</mat-icon>
                            <span>Off</span>
                        </button>
                    </div>
                }
            }
        </mat-menu>

        <!-- MARK: Diffs Client -->
        @if (screenType === 'Client') {
            <!-- Direct les diffs -->
            <div
                class="diffusionListContainer listContainer"
                cdkDropList
                (cdkDropListDropped)="drop($event, toClientFace(face).diffusions, face.faceId)"
            >
                <app-diffusion-list
                    (diffusionsDeleted)="diffusionsDeleted.emit($event)"
                    (diffForScreenDeleted)="diffForScreenDeleted.emit($event)"
                    [type]="screenType"
                    [face]="face"
                ></app-diffusion-list>
            </div>
        }

        <!-- MARK: Diff Wancom -->
        @if (screenType === 'Wancom') {
            <!-- Affichage de la campagne -->
            @for (campaign of toWancomFace(face).campaigns; track $index) {
                <div class="diffusionListContainer listContainer" id="campaignList">
                    <div class="diffusionItem">
                        <!-- Dates de la campagne -->
                        <p class="wancomCampaignDate">
                            {{ campaign.date.start | date: 'dd/MM/YY' }}
                            -
                            {{ campaign.date.end | date: 'dd/MM/YY' }}
                        </p>
                        <!-- Order Form - BDC/FA -->
                        @if (campaign.orderFormNumber && userAuth$.hasRight('CanSeeOrderFormDocument')) {
                            <a
                                class="documentNumber"
                                [matTooltip]="
                                    campaign.orderType === 0 ? 'Ouvrir le bon de commande' : 'Ouvrir la facture'
                                "
                                [href]="getOrderFormLink(campaign)"
                                target="_blank"
                                >{{ getOrderFormName(campaign) }}
                            </a>
                        }
                        <!-- Nom de la campagne -->
                        <p class="wancomCampaignName">
                            {{ campaign.name }}
                            @if (campaign.duration != null) {
                                - {{ campaign.duration }}s
                            }
                        </p>
                        <app-diffusion-list
                            [type]="screenType"
                            [face]="face"
                            [campaign]="campaign"
                            (diffusionsDeleted)="diffusionsDeleted.emit($event)"
                            (diffForScreenDeleted)="diffForScreenDeleted.emit($event)"
                        ></app-diffusion-list>
                    </div>
                </div>
            }
        }
    </div>
</div>
